<div class="bg-white p-3">
    <h1>{{'ERROR_INVALID_URL' | translate}}</h1>
    <p>
        {{'ERROR_INVALID_URL_DESCRIPTION' | translate}}
    </p>
</div>

